// extracted by mini-css-extract-plugin
export var standaloneTable = "_l-0";
export var standaloneTableWithBodyFill = "_l-1";
export var withExtraHeader = "_l-2";